import { first } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    template: `
        <div fxLayout="column">
            <div fxLayout="column" fxLayoutAlign="center center"><spinner style="padding-top: 30px;"></spinner></div>
        </div>
    `
})
export class BriefingUnsubscribeComponent implements OnInit {
    
    constructor(private route: ActivatedRoute,
                private router: Router,
                private snackBar: MatSnackBar, 
                private userService: UserService) {}
    
    complete = wasSuccess => {
        const message = wasSuccess ? `You have successfully unsubscribed.` : `We were unable to unsubscribe you from the briefing. Please try again or contact your site administrator.`;   
        this.router.navigate(['briefings']);
        this.snackBar.open(message, 'OK');
    }

    ngOnInit(): void {
        this.userService.uaUnsubscribeFromBriefing(this.route.snapshot.params.userId, this.route.snapshot.params.briefingId).pipe(
        first()).subscribe(() => this.complete(true), () => this.complete(false));
    }
}